// extracted by mini-css-extract-plugin
export default {"customParagraph":"SalesBusinessActivityDetails_customParagraph__uAwTh","spin_container":"SalesBusinessActivityDetails_spin_container__8W0uE"};